import { Component } from '@angular/core';

@Component({
  selector: 'app-auth-layout-component',
  templateUrl: './auth-layout-component.component.html',
  styleUrl: './auth-layout-component.component.scss',
  standalone: false,
})
export class AuthLayoutComponent {}
